<p-toast></p-toast>

<div class="layout-wrapper"  [ngClass]="containerClass">
  <app-navbar></app-navbar>
  <div class="layout-sidebar sidemenu" >
    <app-sidemenu></app-sidemenu>
  </div>
  <div class="layout-main-container">
    <div class="layout-main">
      <app-main></app-main>
      <div *ngIf="animar" class="spinner-container ">
        <p-progressSpinner ariaLabel="Carregando..." />
      </div>
    </div>
    <app-footer></app-footer>
  </div>
  <div class="layout-mask"></div>
</div>


